import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildCredentialsGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const getAllAccountConnections = buildCredentialsGetterObject('getAllAccountConnections');
export const getAccountConnection = buildCredentialsGetterObject('getAccountConnection');
export const getCredentialsSuggestions = buildCredentialsGetterObject('getCredentialsSuggestions');
export const projectCredentials = buildCredentialsGetterObject('projectCredentials');
export const isLoadingCredsForUser = buildCredentialsGetterObject('isLoadingCredsForUser');
export const userMatchingData = buildCredentialsGetterObject('userMatchingData');

const getters = {
	[getAllAccountConnections.getter]: (state) => state.data,
	[getAccountConnection.getter]: (state) => (connectionId) => state.data[connectionId],
	[getCredentialsSuggestions.getter]: (state) => (workflowId) => state.credentialsSuggestions[workflowId],
	[projectCredentials.getter]: (state) => (projectId) => state.projectCredentials[projectId],
	[isLoadingCredsForUser.getter]: (state) => state.activeFetch, // this is a boolean
	[userMatchingData.getter]: (state) => (credentials) => state.userMatching[credentials] || {},
};

export default getters;
